import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "Service/api/api";
import { IPapersSearch } from "Shared/Types/paper";
import { IUpdateReducerWithCallback } from "Shared/Types/shared";
import { IPaperData } from "Shared/Utils/yup/document";
import type { RootState } from "Redux/store";

const getDocumentsList = createAsyncThunk(
  "documents/getDocumentsList",
  async (params: IPapersSearch | null) => {
    try {
      const response = await api.document.getDocumentList(params);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

const getDocument = createAsyncThunk(
  "documents/getDocument",
  async (id: string) => {
    try {
      const response = await api.document.getDocument(id);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

const deleteDocument = createAsyncThunk(
  "documents/deleteDocument",
  async (id: string, { dispatch, getState }) => {
    try {
      await api.document.deleteDocument(id);
      dispatch(
        getDocumentsList((getState() as RootState).documents.lastListParams),
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

const updateDocument = createAsyncThunk(
  "documents/updateDocument",
  async (
    { id, data, onError, onSuccess }: IUpdateReducerWithCallback<IPaperData>,
    { dispatch, getState },
  ) => {
    try {
      const response = await api.document.updateDocument({ data, id });
      dispatch(
        getDocumentsList((getState() as RootState).documents.lastListParams),
      );
      onSuccess && onSuccess();
      return response.data;
    } catch (error) {
      onError && onError();
      console.error(error);
      throw error;
    }
  },
);

const createDocument = createAsyncThunk(
  "documents/createDocument",
  async (formData: FormData, { dispatch, getState }) => {
    try {
      const response = await api.document.createDocument(formData);
      dispatch(
        getDocumentsList((getState() as RootState).documents.lastListParams),
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);
const document = createAsyncThunk(
  "documents/document",
  async (id: string, { dispatch, getState }) => {
    try {
      const response = await api.document.document(id);
      dispatch(
        getDocumentsList((getState() as RootState).documents.lastListParams),
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export {
  createDocument,
  deleteDocument,
  document,
  getDocument,
  getDocumentsList,
  updateDocument,
};
